// export const API = 'http://localhost:8000/api'
// export const API = 'http://192.168.1.7:8000/api'
// export const API = 'https://omtech-backend.vercel.app/api'
export const API = 'https://backend.omtechauto.in/api'
